import AddToCart, { AddToCartButton } from './components/AddToCart';
import ShowCart, { ShowCartButton } from './components/ShowCart';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelShoppingCartCategory } = opts;
  AddToCartButton(
    bm,
    labelShoppingCartCategory,
    labels.snipcartAddToCart,
    types.snipcartAddToCart,
    opts,
  );
  AddToCart(dc, labels.snipcartAddToCart, types.snipcartAddToCart, opts);
  ShowCartButton(
    bm,
    labelShoppingCartCategory,
    labels.snipcartShowCart,
    types.snipcartShowCart,
    opts,
  );
  ShowCart(dc, labels.snipcartShowCart, types.snipcartShowCart, opts);
};
